<template>
  <div class="tooltip" :class="`theme-${theme}`" :style="cssProps" tabindex="0">
    <div class="trigger">
      <slot name="trigger" />
    </div>
    <div class="tooltip-text-hitbox" :class="{ top, bottom: !top }">
      <div class="tooltip-text interface-small-regular" :class="{ left }">
        <slot name="text" />
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({
  top: {
    type: Boolean,
    required: false,
    default: false,
  },
  left: {
    type: Boolean,
    required: false,
    default: false,
  },
  theme: {
    validator(value) {
      // The value must match one of these strings
      return ["white", "blue"].includes(value);
    },
    default: "blue",
  },
  width: {
    type: Number,
    default: 168,
  },
});

const cssProps = computed(() => {
  return { "--tooltip-width": `${props.width}px` };
});
</script>

<style lang="scss" scoped>
.theme-blue {
  --tooltip-background-color: var(--clr-s8);
  --tooltip-text-color: white;
}

.theme-white {
  --tooltip-background-color: white;
  --tooltip-text-color: var(--clr-n8);
  .tooltip-text {
    box-shadow: var(--shd-tag);
  }
}

.tooltip {
  position: relative;
  display: inline-block;

  &:hover,
  &:focus-within {
    .tooltip-text-hitbox {
      visibility: visible;
    }
  }
  &:focus-visible {
    box-shadow: 0 0 5px 2px #a802e3;
    outline: 2px solid #a802e3;
    .tooltip-text-hitbox {
      visibility: visible;
    }
  }
}

.tooltip-text-hitbox {
  visibility: hidden;
  position: absolute;
  left: 50%;
  margin-left: -17px;
  z-index: 1;
  width: fit-content;
  white-space: wrap;

  &.top {
    bottom: 100%;
    padding-bottom: 7px;

    .tooltip-text::after {
      top: 100%;
      border-color: var(--tooltip-background-color) transparent transparent
        transparent;
    }
  }
  &.bottom {
    top: 100%;
    padding-top: 7px;

    .tooltip-text::after {
      bottom: 100%;
      border-color: transparent transparent var(--tooltip-background-color)
        transparent;
    }
  }

  .tooltip-text {
    position: relative;
    border-radius: 6px;
    width: var(--tooltip-width);
    padding: 4px;
    background-color: var(--tooltip-background-color);
    color: var(--tooltip-text-color);

    &::after {
      content: "";
      position: absolute;
      left: 10%;
      margin-left: -5px;
      border-width: 5px;
      border-style: solid;
    }

    &.left {
      left: unset;
      right: 75%;

      &::after {
        left: unset;
        right: 11%;
      }
    }
  }
}
</style>
